import { useEffect } from 'react'
import { Platform } from 'react-native'

import { useNetInfo } from '@react-native-community/netinfo'

import { useStore } from '../StoreProvider'
import { WebSocketConnectionState } from './SubscriptionClient'

export const useNetworkDetection = () => {
  const netinfo = useNetInfo()
  const store = useStore()
  const setIsNetworkDown = store.network.setIsNetworkDown
  const closeSocketConnection = store.game.closeSocketConnection
  const setWebSocketState = store.network.setWebSocketState

  useEffect(() => {
    if (Platform.OS === 'web') {
      return
    }

    if (!netinfo.isConnected) {
      setIsNetworkDown(true)
      // force websocket to close
      closeSocketConnection('Network is down')
      setWebSocketState(WebSocketConnectionState.unknown)
    } else {
      setIsNetworkDown(false)
      // DEPRECATED: force websocket to re-open after network is back up (we should also be in game...?)
      if (Platform.OS === 'android') {
        store.messages.unsubscribeGraphQLSubscription(true)
        store.messages.createChannelSubscription()
      }
    }
  }, [closeSocketConnection, netinfo.isConnected, setIsNetworkDown, setWebSocketState, store.messages])

  return netinfo.isConnected
}
